function getInvoiceInlinePropertiesString({invoiceInlineProperties, productInstance}) {
  return _.chain(invoiceInlineProperties)
    .map((propertyData) => _.get(productInstance, `propertiesDataById.${_.get(propertyData, 'productProperty.id')}.selectedProductOption.title`))
    .filter(value => value)
    .join(', ')
    .value();
}

export { getInvoiceInlinePropertiesString };